import React, { useState, useEffect } from 'react';
import ContactUsPopupComponent from './ContactUsPopupComponent';

import * as CommonHelper from '../../../../helpers/Common.helper';
import * as EmailService from '../../../../services/Email.service';

const ContactUsPopupContainer = props => {
    const { isShowContactPopup, onClickBtnCloseContactPopup } = props;

    const defaultInfo = {
        title: '',
        email: '',
        company: '',
        name: '',
        phone: '',
        message: ''
    }

    const [info, setInfo] = useState(CommonHelper.clone(defaultInfo))
    useEffect(_ => {

    }, [])

    const onChangeInputText = (key, evt) => {
        console.log(key, evt);
        let newInfo = CommonHelper.clone(info);
        newInfo[key] = evt.target.value;
        setInfo(newInfo);
    }

    const onClickBtnSend = async evt => {
        console.log('onClickBtnSend');
        const { title, email, company, name, phone, message } = info;
        const result = await EmailService.createContactUs(title, email, company, name, phone, message);
        console.log(result);
    }

    return (
        <ContactUsPopupComponent
            info={info}
            onChangeInputText={onChangeInputText}
            onClickBtnSend={onClickBtnSend}
            {...props} />
    )
}

export default ContactUsPopupContainer;